let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("45L5W")).then(() => parcelRequire('ehn1w'));